import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { actions, actionTypes } from "../../../../Redux";
import Headerbar from "../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../Components/InnerLayout/UserInterface";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import ErrorContainer from "../../../Components/ErrorContainer";
import ModelContainer from "../../../Components/ModelContainer";
import { set } from "date-fns";

const PosSettings = (params) => {
  const dispatch = useDispatch();
  const showPosForm = useSelector(
    (state) => state?.settingReducer.pos_form_state
  );
  const setShowPosForm = (formState) =>
    dispatch(actions?.setFormState({ formName: "pos_form_state", formState }));

  const [formType, setFormType] = useState("add");

  // const [integrationModal, setIntegrationModal] = useState(false);
  const integrationModal = useSelector(
    (state) => state?.settingReducer.pos_integration_modal_state
  );
  const setIntegrationModal = (modalState) =>
    dispatch(
      actions?.setModalState({
        modalName: "pos_integration_modal_state",
        modalState,
      })
    );

  // const [showPosForm, setShowPosForm] = useState(false);
  // const [showHistory, setShowHistory] = useState(true);
  const showHistory = useSelector(
    (state) => !state?.settingReducer.pos_form_state
  );
  const posMasterData = useSelector(
    (state) => state?.settingReducer?.pos_master_data
  );
  const posIntegrationData = useSelector(
    (state) => state?.settingReducer?.pos_integration_data
  );
  const posMasterFormOptions = useSelector(
    (state) => state?.settingReducer?.pos_master_form_options
  );
  const posMasterEditFormData = useSelector(
    (state) => state?.settingReducer?.pos_master_Edit_form_data?.posMaster
  );
  console.log(posMasterEditFormData, "jjjjjjjjj");

  useEffect(() => {
    dispatch(actions.getPosMasterData());
    dispatch(actions.getPosMasterFormOptions());
  }, []);

  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />

        <div className="inner-content row mx-0 finance-setting-chart chart-of-accounts">
          <div className="container px-0">
            <div className="accordion mt-3" id="accordionPanelsStayOpenExample">
              {!showPosForm && (
                <div className="accordion-item">
                  <h2
                    className="accordion-header"
                    id="panelsStayOpen-headingOne"
                  >
                    <button
                      className="accordion-button"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#panelsStayOpen-collapseOne"
                      aria-expanded="true"
                      aria-controls="panelsStayOpen-collapseOne"
                    >
                      <div className="col d-flex align-items-center">
                        <h4 className="event-alert p-0 mb-0">
                          POS Station List
                        </h4>
                      </div>{" "}
                    </button>
                  </h2>
                  <div
                    id="panelsStayOpen-collapseOne"
                    className="accordion-collapse collapse show"
                    aria-labelledby="panelsStayOpen-headingOne"
                  >
                    <div className="row mx-0">
                      <div className="container px-0">
                        <div className="shadowclass mt-0">
                          <div className="row justify-content-between align-items-center">
                            <div className="col-md-4">
                              <div className="search-box mt-0">
                                <form>
                                  <input
                                    type="text"
                                    placeholder="Search"
                                    name="keyword1"
                                  />
                                  <input type="submit" />
                                </form>
                              </div>
                            </div>
                          </div>

                          <div className="table-responsive">
                            <table className="checklist-table remove-space inventory_table">
                              <thead>
                                <tr>
                                  <th>
                                    <a href="">Station ID </a>
                                  </th>
                                  <th>
                                    <a href="">Station Name </a>
                                  </th>
                                  <th className="text-right">
                                    <a href="">Status</a>
                                  </th>
                                  <th className="text-right col-md-2">
                                    <a href="">Device</a>
                                  </th>
                                  <th className="text-right">
                                    <a href="">App Version</a>
                                  </th>
                                  <th className="text-right">
                                    <a href=""> Last Upload Update</a>
                                  </th>
                                  <th className="text-right">
                                    <a href="">
                                      Last Pushdown Update &nbsp;&nbsp;
                                    </a>
                                  </th>
                                  <th className="action-td"> Actions </th>
                                </tr>
                              </thead>
                              <tbody>
                                {posMasterData?.posMaster?.map((el) => (
                                  <tr>
                                    <td>{el?.station_id}</td>
                                    <td>{el?.station_name}</td>
                                    <td>{el?.pos_station_status?.name}</td>
                                    <td style={{ textAlign: "right" }}>
                                      {el?.device_identifier}
                                    </td>
                                    <td style={{ textAlign: "right" }}>
                                      {el?.pos_app_version?.version_name}
                                    </td>
                                    <td style={{ textAlign: "right" }}>
                                      14-Jul-2020
                                    </td>
                                    <td style={{ textAlign: "right" }}>
                                      {el?.last_pushdown_update}
                                    </td>
                                    <td>
                                      <p
                                        onClick={() => {
                                          setFormType("edit");
                                          setShowPosForm(true);
                                          dispatch(
                                            actions.getEditPosMasterFormData(
                                              el.id
                                            )
                                          );
                                        }}
                                        className="circle_icon edit_tooltip"
                                      >
                                        <i class="iconSprites edit-icon"></i>{" "}
                                      </p>
                                      <p
                                        class="circle_icon pwr_tooltip on"
                                        onClick={() => {
                                          dispatch(
                                            actions.postPosMasterActiveStatus({
                                              id: el.id,
                                              status:
                                                el?.pos_station_status?.id == 1
                                                  ? "inactive"
                                                  : "active",
                                            })
                                          );
                                        }}
                                      >
                                        <i class="iconSprites pwr-icon"></i>
                                      </p>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>

                          <div
                            onClick={() => {
                              setFormType("add");
                              setShowPosForm(true);
                              // setShowHistory(false);
                            }}
                            class="my-3"
                          >
                            <p class="btn green-btn-revert add-plus">
                              <i class="i-icon"> </i> POS Station List
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {/* /////////////// */}
              {showPosForm && (
                <PosStationForm
                  editFormData={posMasterEditFormData}
                  formType={formType}
                  formOptions={posMasterFormOptions}
                  setShowPosForm={setShowPosForm}
                  // setShowHistory={setShowHistory}
                />
              )}{" "}
              {/* ////// /////*/}
              {showPosForm && (
                <>
                  <div
                    className="accordion"
                    id="accordionPanelsStayOpenExample"
                  >
                    <div className="accordion-item">
                      <h2
                        className="accordion-header"
                        id="panelsStayOpen-headingOne"
                      >
                        <button
                          className="accordion-button"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#panelsStayOpen-collapseOne"
                          aria-expanded="true"
                          aria-controls="panelsStayOpen-collapseOne"
                        >
                          <div className="col d-flex align-items-center">
                            <h4 className="event-alert p-0 mb-0">
                              POS Station Integration Settings
                            </h4>
                          </div>
                        </button>
                      </h2>
                      <div
                        id="panelsStayOpen-collapseOne"
                        className="accordion-collapse collapse show"
                        aria-labelledby="panelsStayOpen-headingOne"
                      >
                        <div className="row mx-0">
                          <div className="container px-0">
                            <div className="shadowclass mt-0">
                              <div className="table-responsive">
                                <table className="checklist-table remove-space inventory_table">
                                  <thead>
                                    <tr>
                                      <th className="col-1">
                                        {" "}
                                        Upload/Download
                                      </th>
                                      <th class="col-2">Applicable Module</th>
                                      <th class="col-2">Data Type</th>
                                      <th class="col-2">Trigger Type</th>
                                      <th class="col-2">Frequency</th>
                                      <th class="col-2">Last Successful Job</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {posIntegrationData?.map((el) => (
                                      <tr>
                                        <th className="col-1">
                                          {el.upload_download}
                                        </th>
                                        <th class="col-2">
                                          {el.applicable_module}
                                        </th>
                                        <th class="col-2"> {el.data_type}</th>
                                        <th class="col-2">
                                          {" "}
                                          {el.trigger_type}
                                        </th>
                                        <th class="col-2"> {el.frequency}</th>
                                        <th class="col-2"> </th>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                              <div
                                onClick={() => {
                                  setIntegrationModal(true);
                                }}
                                class="my-3"
                              >
                                <p class="btn green-btn-revert add-plus">
                                  <i class="i-icon"> </i> Add Integration
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <IntegrationForm
                    integrationModal={integrationModal}
                    setIntegrationModal={setIntegrationModal}
                    formOptions={posMasterFormOptions}
                  />
                </>
              )}
              {/* //////////////// */}
              {showHistory && (
                <div className="accordion-item">
                  <h2
                    className="accordion-header"
                    id="panelsStayOpen-headingTwo"
                  >
                    <button
                      className="accordion-button"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#panelsStayOpen-collapseTwo"
                      aria-expanded="true"
                      aria-controls="panelsStayOpen-collapseTwo"
                    >
                      <div className="col d-flex align-items-center">
                        <h4 className="event-alert p-0 mb-0">History</h4>
                      </div>{" "}
                    </button>
                  </h2>
                  <div
                    id="panelsStayOpen-collapseTwo"
                    className="accordion-collapse collapse"
                    aria-labelledby="panelsStayOpen-headingTwo"
                  >
                    <div className="row mx-0">
                      <div className="container px-0">
                        <div className="shadowclass mt-0">
                          <div className="row justify-content-between align-items-center">
                            <div className="col-md-4">
                              <div className="search-box mt-0">
                                <input
                                  type="text"
                                  placeholder="Search"
                                  name="keyword1"
                                />
                                <input type="submit" />
                              </div>
                            </div>
                          </div>

                          <div className="table-responsive">
                            <table className="checklist-table remove-space inventory_table">
                              <thead>
                                <tr>
                                  <th>Start</th>
                                  <th>End</th>
                                  <th>Field</th>
                                  <th>Value</th>
                                  <th>Replacement Value</th>
                                </tr>
                              </thead>
                              <tbody>
                                {posMasterData?.posMasterHistory?.map((el) => (
                                  <tr>
                                    <td width="15%">{el.start}</td>
                                    <td width="15%">{el.end}</td>
                                    <td width="25%">{el.field}</td>
                                    <td width="20%">
                                      <span class="text-ellipsis">
                                        <span
                                          class="tooltipst"
                                          title="0B650AC3-D227-4292-9DF1-A5B2F59D4D23"
                                        >
                                          {el.value}
                                        </span>
                                      </span>
                                    </td>
                                    <td width="25%">
                                      <span class="text-ellipsis">
                                        <span
                                          class="tooltipst"
                                          title="0B650AC3-D227-4292-9DF1-A5B2F59D4D"
                                        >
                                          {el?.replacement_value}
                                        </span>
                                      </span>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};

const PosStationForm = ({
  formType,
  editFormData,
  formOptions,
  setShowPosForm,
  // setShowHistory,
}) => {
  const dispatch = useDispatch();
  const [stationType, setStationType] = useState("pos_order");
  const posStationSchema = yup.object({
    station_name: yup.string().required(),
    station_type: yup.string().required(),
    station_status_id: yup.string().required(),
    device_maker_id: yup.string().required(),
    device_identifier: yup.string().required(),
    timeout_settings:
      stationType === "pos_order" ? yup.string().required() : yup.string(),
    service_charge:
      stationType === "pos_order" ? yup.string().required() : yup.string(),
    service_charges_applied:
      stationType === "pos_order" ? yup.string().required() : yup.string(),
    auto_recipt_print:
      stationType === "pos_order" ? yup.string().required() : yup.string(),
    remove_hold_feature:
      stationType === "pos_order" ? yup.string().required() : yup.string(),
    auto_exit_ticket_fire:
      stationType === "pos_order" ? yup.string().required() : yup.string(),
    auto_fire_allitem_on_logout:
      stationType === "pos_order" ? yup.string().required() : yup.string(),
    pos_room_id:
      stationType === "pos_order" ? yup.string().required() : yup.string(),
    ticket_details:
      stationType === "pos_order" ? yup.string().required() : yup.string(),
    landing_page_main_widget_preferences:
      stationType === "pos_order" ? yup.string().required() : yup.string(),
    auto_prepare_order_items:
      stationType === "pos_order"
        ? yup.string().nullable()
        : yup.string().required(),
  });

  const posStationDefaultAddState = {
    station_name: "",
    station_type: "",
    station_status_id: "",
    device_maker_id: "",
    device_identifier: "",
    timeout_settings: "",
    service_charge: "",
    service_charges_applied: "",
    auto_recipt_print: "",
    remove_hold_feature: "",
    auto_exit_ticket_fire: "",
    auto_fire_allitem_on_logout: "",
    pos_room_id: "",
    ticket_details: "",
    landing_page_main_widget_preferences: "",
    auto_prepare_order_items: "",
    fire_button_outcome: "",
    slide_pay_triggers_fire_all: "",
  };
  const posStationDefaultEditState = {
    station_name: editFormData?.station_name,
    station_type: editFormData?.station_type,
    station_status_id: editFormData?.station_status_id.toString(),
    device_maker_id: editFormData?.device_maker_id.toString(),
    device_identifier: editFormData?.device_identifier,
    timeout_settings: editFormData?.timeout_settings, //
    service_charge: editFormData?.service_charge?.toString(),
    service_charges_applied: editFormData?.service_charges_applied,
    auto_recipt_print: editFormData?.auto_recipt_print,
    remove_hold_feature: editFormData?.remove_hold_feature,
    auto_exit_ticket_fire: editFormData?.auto_exit_ticket_fire,
    auto_fire_allitem_on_logout: editFormData?.auto_fire_allitem_on_logout,
    pos_room_id: editFormData?.pos_room_id,
    ticket_details: editFormData?.ticket_details,
    landing_page_main_widget_preferences:
      editFormData?.landing_page_main_widget_preferences,
    auto_prepare_order_items: editFormData?.auto_prepare_order_items,
    fire_button_outcome: editFormData?.fire_button_outcome,
    slide_pay_triggers_fire_all: editFormData?.slide_pay_triggers_fire_all,
  };
  const {
    register: posStationRegister,
    formState: { errors: posStationErrors },
    handleSubmit: posStationSubmit,
    reset: posStationReset,
    setValue,
  } = useForm({
    resolver: yupResolver(posStationSchema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues:
      formType === "add"
        ? posStationDefaultAddState
        : posStationDefaultEditState,
  });
  useEffect(() => {
    if (formType === "edit") posStationReset(posStationDefaultEditState);
    else posStationReset(posStationDefaultAddState);
    setStationType(editFormData?.station_type);
  }, [editFormData, formType]);

  const submitForm = (data) => {
    console.log(data, "ccccccccc", formType, editFormData, "dsas");
    if (formType === "edit")
      dispatch(
        actions.postEditPosMasterFormData({ id: editFormData.id, ...data })
      );
    else dispatch(actions.postAddPosMasterFormData(data));
    // setShowPosForm(false);
    // setShowHistory(true);
  };
  return (
    <div className="inner-content row mx-0 finance-setting-chart chart-of-accounts">
      <div className="container px-0">
        <form onSubmit={posStationSubmit(submitForm)}>
          {console.log(posStationErrors, "llllll")}
          <div className="row lbrSettingMs d-flex">
            <div className="col-md-12 modify">
              <div className="shadowclass mt-4 d-flex flex-wrap align-content-start">
                <h4 className="event-alert w-100 mb-4">POS Station Details</h4>
                <div className="d-flex calc-height w-100 flex-wrap">
                  <div className="settings-left-content fixed-pos col-3">
                    <ul className="settingMenus">
                      <li id="AccDetail_li" className="active">
                        <a>
                          STATION <br /> INFO
                        </a>
                      </li>
                      <li id="Address_li" className="">
                        <a>
                          {stationType === "pos_order" ? "POS" : "KDS"}{" "}
                          OPERATIONAL <br /> SETTINGS
                        </a>
                      </li>
                      {/* <li id="FinSettings_li" className="">
                                <a href="#_" id="FinSettings_dayTime_a">
                                  EMPLOYEE <br />
                                  BENEFITS
                                </a>
                              </li>
                              <li id="FinSettings_li" className="">
                                <a href="#_" id="FinSettings_dayTime_a">
                                  OTHER ADMIN
                                </a>
                              </li> */}
                    </ul>
                  </div>

                  <div className="settings-right-content scrolling col-9">
                    <div className="date-sec-scroll">
                      <div
                        id="AccDetail_dayTime_div"
                        className="row-fluid scroll-change full_div"
                        day_time="AccDetail"
                      >
                        <div className="form-secs">
                          <h4>Station Info</h4>
                          <ul class="ingredient-info edit-shift">
                            <li>
                              <label class="required">POS Station Name</label>
                              <div class="input-group d-flex align-items-center pt-0">
                                <input
                                  {...posStationRegister("station_name")}
                                  type="text"
                                />{" "}
                                <ErrorContainer
                                  errors={posStationErrors}
                                  name="station_name"
                                />
                              </div>
                            </li>
                            <li>
                              <label class="required">POS Station Type</label>
                              <div class="input-group select-div">
                                <select
                                  {...posStationRegister("station_type")}
                                  onChange={(e) => {
                                    console.log(e.target.value);
                                    setStationType(e.target.value);
                                  }}
                                  // onClick={(e) =>
                                  //   console.log("aaaa", e.target.value)
                                  // }
                                >
                                  <option value="">Select</option>
                                  {formOptions?.station_type?.map((el) => (
                                    <option value={el?.value}>
                                      {el?.label}
                                    </option>
                                  ))}
                                </select>{" "}
                                <ErrorContainer
                                  errors={posStationErrors}
                                  name="station_type"
                                />
                              </div>
                            </li>
                            <li>
                              <label class="required">POS Station Status</label>
                              <div class="input-group select-div">
                                <select
                                  {...posStationRegister("station_status_id")}
                                >
                                  <option value="">Select</option>
                                  {formOptions?.stationStatus?.map((el) => (
                                    <option value={el.value}>{el.label}</option>
                                  ))}
                                </select>{" "}
                                <ErrorContainer
                                  errors={posStationErrors}
                                  name="station_status_id"
                                />
                              </div>
                            </li>
                            <li>
                              <label class="required">Device Identifier</label>
                              <div class="input-group d-flex align-items-center pt-0">
                                <input
                                  {...posStationRegister("device_identifier")}
                                  type="text"
                                />{" "}
                                <ErrorContainer
                                  errors={posStationErrors}
                                  name="device_identifier"
                                />
                              </div>
                            </li>
                            <li>
                              <label class="required">Device Maker</label>
                              <div class="input-group select-div">
                                <select
                                  {...posStationRegister("device_maker_id")}
                                >
                                  <option value="">Select</option>
                                  {formOptions?.deviceMaker?.map((el) => (
                                    <option value={el.value}>{el.label}</option>
                                  ))}
                                </select>{" "}
                                <ErrorContainer
                                  errors={posStationErrors}
                                  name="device_maker_id"
                                />
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>

                      <div
                        id="Address_dayTime_div"
                        className="row-fluid scroll-change full_div"
                        day_time="Address"
                      >
                        <div className="form-secs">
                          <h4>
                            {" "}
                            {stationType === "pos_order" ? "POS" : "KDS"}{" "}
                            Operational Settings{" "}
                          </h4>
                          <ul class="ingredient-info edit-shift">
                            {stationType === "pos_order" ? (
                              <>
                                {" "}
                                <li>
                                  <label class="required">
                                    Station Timeout Setting
                                  </label>
                                  <div class="input-group select-div">
                                    <select
                                      {...posStationRegister(
                                        "timeout_settings"
                                      )}
                                      class="valid"
                                      disabled=""
                                    >
                                      <option value="">Select</option>
                                      {formOptions?.timeout?.map((el) => (
                                        <option value={el.value}>
                                          {el.label}
                                        </option>
                                      ))}
                                    </select>{" "}
                                    <ErrorContainer
                                      errors={posStationErrors}
                                      name="timeout_settings"
                                    />
                                  </div>
                                </li>
                                <li>
                                  <label class="required">Service Charge</label>
                                  <div class="input-group d-flex align-items-center pt-0">
                                    <input
                                      {...posStationRegister("service_charge")}
                                      type="text"
                                    />{" "}
                                    <ErrorContainer
                                      errors={posStationErrors}
                                      name="service_charge"
                                    />
                                  </div>
                                </li>
                                <li>
                                  <label class="required">
                                    Service Charge Applied
                                  </label>
                                  <div class="input-group select-div">
                                    <select
                                      {...posStationRegister(
                                        "service_charges_applied"
                                      )}
                                      class="valid"
                                      disabled=""
                                    >
                                      <option value="">Select</option>
                                      {formOptions?.service_charges_applied?.map(
                                        (el) => (
                                          <option value={el.value}>
                                            {el.label}
                                          </option>
                                        )
                                      )}
                                    </select>{" "}
                                    <ErrorContainer
                                      errors={posStationErrors}
                                      name="service_charges_applied"
                                    />
                                  </div>
                                </li>
                                <li>
                                  <label class="required">
                                    Auto-Receipt Print?
                                  </label>
                                  <div class="input-group select-div">
                                    <select
                                      {...posStationRegister(
                                        "auto_recipt_print"
                                      )}
                                      class="valid"
                                      disabled=""
                                    >
                                      <option value="">Select</option>
                                      {formOptions?.yes_no?.map((el) => (
                                        <option value={el.value}>
                                          {el.label}
                                        </option>
                                      ))}
                                    </select>{" "}
                                    <ErrorContainer
                                      errors={posStationErrors}
                                      name="auto_recipt_print"
                                    />
                                  </div>
                                </li>
                                <li>
                                  <label class="required">
                                    Remove Hold Feature
                                  </label>
                                  <div class="input-group select-div">
                                    <select
                                      {...posStationRegister(
                                        "remove_hold_feature"
                                      )}
                                      class="valid"
                                      disabled=""
                                    >
                                      <option value="">Select</option>
                                      {formOptions?.yes_no?.map((el) => (
                                        <option value={el.value}>
                                          {el.label}
                                        </option>
                                      ))}
                                    </select>{" "}
                                    <ErrorContainer
                                      errors={posStationErrors}
                                      name="remove_hold_feature"
                                    />
                                  </div>
                                </li>
                                <li>
                                  <label class="required">
                                    Auto-Exit Ticket Upon Fire
                                  </label>
                                  <div class="input-group select-div">
                                    <select
                                      {...posStationRegister(
                                        "auto_exit_ticket_fire"
                                      )}
                                      class="valid"
                                      disabled=""
                                    >
                                      <option value="">Select</option>
                                      {formOptions?.auto_exit_ticket_upen_fire?.map(
                                        (el) => (
                                          <option value={el.value}>
                                            {el.label}
                                          </option>
                                        )
                                      )}
                                    </select>{" "}
                                    <ErrorContainer
                                      errors={posStationErrors}
                                      name="auto_exit_ticket_fire"
                                    />
                                  </div>
                                </li>
                                <li>
                                  <label class="required">
                                    Auto-Fire All Items Upon User Logout
                                  </label>
                                  <div class="input-group select-div">
                                    <select
                                      {...posStationRegister(
                                        "auto_fire_allitem_on_logout"
                                      )}
                                      class="valid"
                                      disabled=""
                                    >
                                      <option value="">Select</option>
                                      {formOptions?.yes_no?.map((el) => (
                                        <option value={el.value}>
                                          {el.label}
                                        </option>
                                      ))}
                                    </select>{" "}
                                    <ErrorContainer
                                      errors={posStationErrors}
                                      name="auto_fire_allitem_on_logout"
                                    />
                                  </div>
                                </li>
                                <li>
                                  <label class="required">
                                    Default Room Upon Login
                                  </label>
                                  <div class="input-group select-div">
                                    <select
                                      {...posStationRegister("pos_room_id")}
                                      class="valid"
                                      disabled=""
                                    >
                                      <option value="">Select</option>
                                      {formOptions?.posRooms?.map((el) => (
                                        <option value={el.value}>
                                          {el.label}
                                        </option>
                                      ))}
                                    </select>{" "}
                                    <ErrorContainer
                                      errors={posStationErrors}
                                      name="pos_room_id"
                                    />
                                  </div>
                                </li>
                                <li>
                                  <label class="required">
                                    Ticket Details Toggle
                                  </label>
                                  <div class="input-group select-div">
                                    <select
                                      {...posStationRegister("ticket_details")}
                                      class="valid"
                                      disabled=""
                                    >
                                      <option value="">Select</option>
                                      <option value="show">Show</option>
                                      <option value="hide">Hide</option>
                                    </select>{" "}
                                    <ErrorContainer
                                      errors={posStationErrors}
                                      name="ticket_details"
                                    />
                                  </div>
                                </li>
                                <li>
                                  <label class="required">
                                    Auto-Print Receipts Upon Payment?{" "}
                                  </label>
                                  <div class="input-group select-div">
                                    <select
                                      {...posStationRegister(
                                        "auto_recipt_print"
                                      )}
                                      class="valid"
                                      disabled=""
                                    >
                                      <option value="">Select</option>
                                      {formOptions?.yes_no?.map((el) => (
                                        <option value={el.value}>
                                          {el.label}
                                        </option>
                                      ))}
                                    </select>{" "}
                                    <ErrorContainer
                                      errors={posStationErrors}
                                      name="auto_recipt_print"
                                    />
                                  </div>
                                </li>
                                <li>
                                  <label class="required">
                                    Landing Page Main Widget Preferences{" "}
                                  </label>
                                  <div class="input-group select-div">
                                    <select
                                      {...posStationRegister(
                                        "landing_page_main_widget_preferences"
                                      )}
                                    >
                                      <option value="">Select</option>
                                      {formOptions?.landing_page_main_widget_preferences?.map(
                                        (el) => (
                                          <option value={el.value}>
                                            {el.label}
                                          </option>
                                        )
                                      )}
                                    </select>{" "}
                                    <ErrorContainer
                                      errors={posStationErrors}
                                      name="landing_page_main_widget_preferences"
                                    />
                                  </div>
                                </li>
                                <li>
                                  <label class="required">
                                    Fire Button Outcome{" "}
                                  </label>
                                  <div class="input-group select-div">
                                    <select
                                      {...posStationRegister(
                                        "fire_button_outcome"
                                      )}
                                    >
                                      <option value="">Select</option>
                                      {formOptions?.fire_button_outcome?.map(
                                        (el) => (
                                          <option value={el.value}>
                                            {el.label}
                                          </option>
                                        )
                                      )}
                                    </select>{" "}
                                    <ErrorContainer
                                      errors={posStationErrors}
                                      name="fire_button_outcome"
                                    />
                                  </div>
                                </li>
                                <li>
                                  <label class="required">
                                    Slide to Pay triggers Fire All{" "}
                                  </label>
                                  <div class="input-group select-div">
                                    <select
                                      {...posStationRegister(
                                        "slide_pay_triggers_fire_all"
                                      )}
                                    >
                                      <option value="">Select</option>
                                      {formOptions?.yes_no?.map((el) => (
                                        <option value={el.value}>
                                          {el.label}
                                        </option>
                                      ))}
                                    </select>
                                    <ErrorContainer
                                      errors={posStationErrors}
                                      name="slide_pay_triggers_fire_all"
                                    />
                                  </div>
                                </li>
                              </>
                            ) : (
                              <li>
                                <label class="required">
                                  Auto-Prepare Order Items Upon:{" "}
                                </label>
                                <div class="input-group select-div">
                                  <select
                                    {...posStationRegister(
                                      "auto_prepare_order_items"
                                    )}
                                    class="valid"
                                    disabled=""
                                  >
                                    <option value="">Select</option>
                                    {formOptions?.auto_prepare_order_items?.map(
                                      (el) => (
                                        <option value={el.value}>
                                          {el.label}
                                        </option>
                                      )
                                    )}
                                  </select>{" "}
                                  <ErrorContainer
                                    errors={posStationErrors}
                                    name="auto_prepare_order_items"
                                  />
                                </div>
                              </li>
                            )}
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row mx-0">
            <div class="container px-0 d-flex col-12">
              <div class="btns col-4 d-flex justify-content-end py-4 col-12">
                <button
                  onClick={() => {
                    setShowPosForm(false);
                    // setShowHistory(true);
                  }}
                  id="cancel"
                  type="button"
                >
                  Cancel
                </button>
                <button type="submit">Save</button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

const IntegrationForm = ({
  integrationModal,
  setIntegrationModal,
  formOptions,
}) => {
  const dispatch = useDispatch();
  const integrationFormSchema = yup.object({
    upload_download: yup.string().required(),
    applicable_module: yup.string().required(),
    data_type: yup.string().required(),
    trigger_type: yup.string().required(),
    frequency: yup.string().required(),
  });
  const defaultIntegrationModalValues = {
    upload_download: "",
    applicable_module: "",
    data_type: "",
    trigger_type: "",
    frequency: "",
  };
  const {
    register: integrationFormRegister,
    formState: { errors: integrationFormError },
    handleSubmit: integrationFormSubmit,
    reset: integrationFormReset,
    setValue,
  } = useForm({
    resolver: yupResolver(integrationFormSchema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: defaultIntegrationModalValues,
  });

  const submitData = (data) => {
    console.log(data, "in submit");
    dispatch(actions.postPosIntegrationSetting(data));
  };

  return (
    <ModelContainer
      title="Add POS Integration Settings"
      open={integrationModal}
      closeModal={() => setIntegrationModal(false)}
      submitModal={integrationFormSubmit(submitData)}
      // submitModal={editAccountSubmit(submitEditAccount)}
    >
      <form>
        <div className="form-list">
          <ul className="px-0">
            {/*edit account 1 */}
            <li>
              <label className="required"> Select Upload/Download </label>
              <div className="input-wrap select-div">
                <select
                  {...integrationFormRegister("upload_download")}
                  style={{ color: "rgb(170, 170, 170)" }}
                >
                  <option value={""}> Select Account </option>
                  {formOptions?.upload_download?.map((el) => {
                    return <option value={el.value}>{el.label}</option>;
                  })}
                </select>
                <ErrorContainer
                  errors={integrationFormError}
                  name="upload_download"
                />
              </div>
            </li>
            <li>
              <label className="required"> Applicable Module </label>
              <div className="input-wrap select-div">
                <select
                  {...integrationFormRegister("applicable_module")}
                  style={{ color: "rgb(170, 170, 170)" }}
                  onChange={(e) =>
                    dispatch(actions.getApplicableModule(e.target.value))
                  }
                >
                  <option value={""}> Select Account </option>
                  {formOptions?.applicable_module?.map((el) => {
                    return <option value={el.value}>{el.label}</option>;
                  })}
                </select>
                <ErrorContainer
                  errors={integrationFormError}
                  name="applicable_module"
                />
              </div>
            </li>
            <li>
              <label className="required"> Data Type</label>
              <div className="input-wrap select-div">
                <select
                  {...integrationFormRegister("data_type")}
                  style={{ color: "rgb(170, 170, 170)" }}
                >
                  <option value={""}> Select </option>
                  {formOptions?.data_type?.map((el) => {
                    return <option value={el.value}>{el.label}</option>;
                  })}
                </select>
                <ErrorContainer
                  errors={integrationFormError}
                  name="data_type"
                />
              </div>
            </li>
            <li>
              <label className="required"> Trigger Type</label>
              <div className="input-wrap select-div">
                <select
                  {...integrationFormRegister("trigger_type")}
                  style={{ color: "rgb(170, 170, 170)" }}
                  onChange={(e) =>
                    dispatch(actions.getFrequency(e.target.value))
                  }
                >
                  <option value={""}> Select Account </option>
                  {formOptions?.trigger_type.map((el) => {
                    return <option value={el.value}>{el.label}</option>;
                  })}
                </select>
                <ErrorContainer
                  errors={integrationFormError}
                  name="trigger_type"
                />
              </div>
            </li>
            <li>
              <label className="required"> Frequency </label>
              <div className="input-wrap select-div">
                <select
                  {...integrationFormRegister("frequency")}
                  style={{ color: "rgb(170, 170, 170)" }}
                >
                  <option value={""}> Select </option>
                  {formOptions?.frequency?.map((el) => {
                    return <option value={el.value}>{el.label}</option>;
                  })}
                </select>
                <ErrorContainer
                  errors={integrationFormError}
                  name="frequency"
                />
              </div>
            </li>
          </ul>
        </div>
      </form>
    </ModelContainer>
  );
};
export default PosSettings;
